import { Box, Flex } from "@chakra-ui/react";
import React, { Fragment } from "react";
import GameSelector from "../../components/GameComponents/GameSelector/GameSelector";
import Seo from "./seo";
import GameTypeSelector from "../../components/GameComponents/GameTypeSelector/GameTypeSelector";
import useCheckLogin from "../../hook/useCheckLogin";
import PlatformSelectorRight from "../../components/GameComponents/PlatformSelector/PlatformSelectorRight";
import useDeviceType from "../../hook/useDeviceType";
import PlatformSelectorMobile from "../../components/GameComponents/PlatformSelector/PlatformSelectorMobile";

const Table = ({ gameMainTypeFromProps }) => {
  const { isMachineUser, isMachineDomain } = useCheckLogin();
  const isMobile = useDeviceType() === "Mobile";
  const isTablet = useDeviceType() === "Tablet";

  return (
    <Fragment>
      <Seo />
      <Flex
        flex={1}
        h={{
          base: "auto",
          md: "calc(100%)",
        }}
        maxH={{
          base: "unset",
          md: "calc(100dvh - 125px)",
        }}
        direction={{
          base: "column",
          md: "row",
        }}
      >
        <Box
          position="sticky"
          top="65px"
          left="0px"
          mb={{
            base: "10px",
            md: "unset",
          }}
          zIndex={1}
        >
          <Box
            display={{
              base: "none",
              sm: "block",
            }}
            position="relative"
            zIndex={1000}
            w={{
              base: "220px",
            }}
          >
            <PlatformSelectorRight
              gameMainTypeFromProps={gameMainTypeFromProps}
            />
          </Box>
          <Box
            display={{
              base: "block",
              sm: "none",
            }}
          >
            <PlatformSelectorMobile
              gameMainTypeFromProps={gameMainTypeFromProps}
            />
          </Box>
        </Box>
        <Flex flex={1}>
          <Box
            py={{
              // md: "home-space",
              base: "0",
            }}
            display={{
              base: "block",
              sm: "none",
            }}
            // pl="common-y"
            pr="5px"
          >
            <GameTypeSelector gameMainTypeFromProps={gameMainTypeFromProps} />
          </Box>
          <Flex
            gap={{
              base: "0",
              md: "10px",
            }}
            py={{
              base: "0",
              md: "home-space",
            }}
            px="common-y"
            mb={{
              base: "60px",
              sm: "0px",
            }}
            w={{
              base: "100%",
            }}
            flexDirection={{
              base: "column",
              md: "column",
            }}
            flex={1}
            align={"center"}
          >
            <Box
              flex={1}
              h="100%"
              w="100%"
              maxW={{
                md: "calc(100dvw - 220px)",
              }}
              pb={{
                sm: "110px",
              }}
              overflowX="scroll"
            >
              <GameSelector
                hiddenTitle
                isGridXLayout={!isMobile}
                gameMainTypeFromProps={gameMainTypeFromProps}
                topLayout={!isMobile && !isTablet}
              />
            </Box>
          </Flex>
        </Flex>

        {/* <JackpotList fixed /> */}
      </Flex>
    </Fragment>
  );
};

export default Table;
